import { apiCall } from "../../utils/servicesUtils"

const BASE_URL = process.env.REACT_APP_BACKEND_URL

export const apiPostStartThread = (
    image: Blob,
    projectId: string,
    threadName?: string
): Promise<IImage> => {
    const urlFetch = `${BASE_URL}/api/v2/threads:start`
    const formData = new FormData()
    formData.append('image', image, 'image.png')
    formData.append('project_id', projectId)
    if (threadName) {
        formData.append('thread_name', threadName)
    }

    return apiCall(
        urlFetch,
        'POST',
        formData,
        true
    )
}

export const apiPostStartThreadWithPrompt = (
    prompt: string,
    projectId: string,
    model: 'fast' | 'detailed' = 'fast',
    threadName?: string
): Promise<IImage> => {
    const urlFetch = `${BASE_URL}/api/v2/threads:start-from-prompt`

    return apiCall(
        urlFetch,
        'POST',
        JSON.stringify({
            prompt,
            project_id: projectId,
            model: model === 'fast' ? 'google' : 'google-pro',
            thread_name: threadName
        })
    )
}

export const apiDeleteThread = (
    projectId: string,
    threadId: string
): Promise<{ success: boolean }> => {
    const urlFetch = `${BASE_URL}/api/projects/${projectId}/threads/${threadId}`
    return apiCall(
        urlFetch,
        'DELETE'
    )
}

export const apiPatchThread = (
    projectId: string,
    threadId: string,
    newName: string
): Promise<{ success: boolean }> => {
    const urlFetch = `${BASE_URL}/api/projects/${projectId}/threads/${threadId}`

    return apiCall(
        urlFetch,
        'PATCH',
        JSON.stringify({
            name: newName
        })
    )
}

export const apiDeletePicture = (
    projectId: string,
    threadId: string,
    pictureId: string
): Promise<{ thread_deleted?: boolean } | void> => {
    const urlFetch = `${BASE_URL}/api/projects/${projectId}/threads/${threadId}/pictures/${pictureId}`
    return apiCall(
        urlFetch,
        'DELETE'
    )
}

export const apiPostSignUrls = (
    projectId: string,
    threadId: string,
    mediaIds: string[],
    mediaType: 'pictures' | 'videos'
): Promise<{ signed_urls: Record<string, string> }> => {
    const urlFetch = `${BASE_URL}/api/projects/${projectId}/threads/${threadId}/${mediaType}:sign`
    return apiCall(
        urlFetch,
        'POST',
        JSON.stringify({ media_ids: mediaIds })
    )
}

